import { useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { theme } from '../constants';
import { svg } from '../assets/svg';
import { components } from '../components';
import home from '../assets/nestfin/key.png'
import owner from '../assets/nestfin/house.png'
import useApi from '../customHook/useApi';




export interface RawEmployeeDetails {
    employee_id: string;
    employee_name: string;
    designation: string;
    department: string;
    sub_department: string;
    email_id: string;
    contact_number: string;
    work_location: string;
    join_date: string;
    band: string;
    cost_center_code: string;
    cost_center_name: string;
    date_of_birth: string;
    gender: string;
    primary_manager: string;
    secondary_manager: string;
    extension_number: string;
    alternate_contact_number: string;
    blood_group: string;
    photo: string;
}
export const Onboarding1: React.FC = () => {
    const { pathname } = useLocation();
    const navigate = hooks.useNavigate();

    const buttons = [
        {
            title: 'Rent as Tenant',
            path: '/onbording3',
            icon: home
        },
        {
            title: 'Rent as Owner',
            path: '/onbording3',
            icon: owner
        },
    ];



    // Start Component Here 

    const renderTitle = (): JSX.Element => {
        return (
            <div className='container'>
                <p className='heading'>What are you looking for?</p>
            </div>
        );
    };

    const renderDescription = (): JSX.Element => {
        return (
            <div className="container">
                <p className="description-text">
                    You can start with this later can be changed
                </p>
            </div>
        );
    };

    const renderButtons = (): JSX.Element => (

        <div
            style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                padding: '36px 16px 36px 16px',
                background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.47) 0%, #FFFFFF 100%)',
                backdropFilter: 'blur(4px)',
                boxSizing: 'border-box',
            }}
        >
            <div
                className='button-container'
                style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
            >
                {renderTitle()}
                {renderDescription()}

                {buttons.map((btn, index) => (
                    <div
                        key={index}
                        id="onbording1"
                        className={index === 0 ? 'active-button' : 'inactive-button'}
                        onClick={() => {
                            if (btn.title === 'Rent as Owner') {
                                window.open('https://play.google.com/store/apps?hl=en_IN', '_blank');
                            } else {
                                navigate(btn.path);
                            }
                        }}
                    >
                        <img src={btn.icon} alt="" className="onboarding-icon" />
                        <span>{btn.title}</span>
                    </div>
                ))}


            </div >
        </div>
    );

    return (

        <div style={{ position: 'relative', height: '100dvh', overflow: 'hidden' }}>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <img
                    src={require('../assets/nestfin/mainb1.jpg')}
                    alt='Onboarding Visual'
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                {renderButtons()}
            </div>
        </div>

    );
};



// ***************** 02-07-2025 CODE
// import { useLocation } from 'react-router-dom';
// import React, { useEffect } from 'react';
// import useEmblaCarousel from 'embla-carousel-react';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { theme } from '../constants';
// import { svg } from '../assets/svg';
// import { components } from '../components';
// import home from '../assets/nestfin/key.png'
// import owner from '../assets/nestfin/house.png'
// import useApi from '../customHook/useApi';




// export interface RawEmployeeDetails {
//     employee_id: string;
//     employee_name: string;
//     designation: string;
//     department: string;
//     sub_department: string;
//     email_id: string;
//     contact_number: string;
//     work_location: string;
//     join_date: string;
//     band: string;
//     cost_center_code: string;
//     cost_center_name: string;
//     date_of_birth: string;
//     gender: string;
//     primary_manager: string;
//     secondary_manager: string;
//     extension_number: string;
//     alternate_contact_number: string;
//     blood_group: string;
//     photo: string;
// }
// export const Onboarding1: React.FC = () => {
//     const { pathname } = useLocation();
//     const navigate = hooks.useNavigate();

//     const buttons = [
//         {
//             title: 'Rent as Tenant',
//             path: '/onbording3',
//             icon: home
//         },
//         {
//             title: 'Rent as Owner',
//             path: '/onbording3',
//             icon: owner
//         },
//     ];



//     // const { data: employeeRawData, loading: employeeIdLoading } = useApi<{
//     //     success: boolean;
//     //     data: RawEmployeeDetails[];
//     // }>(`/`, {
//     //     method: "GET",
//     // });

//     // const { data, loading } = useApi<any>("/", {
//     //     method: "GET",
//     // });

//     // useEffect(() => {
//     //     if (data && !loading) {
//     //         console.log("API Response:", data);
//     //     }
//     // }, [data, loading]);

//     // Start Component Here

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container'>
//                 <p className='heading'>What are you looking for?</p>
//                 {/* <text.H2
//                     style={{
//                         textAlign: 'center',
//                         textTransform: 'capitalize',
//                         color: "#7065F0",
//                         lineHeight: 1,
//                     }}
//                 >
//                     What are you looking for?
//                 </text.H2> */}
//             </div>
//         );
//     };

//     const renderDescription = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <p className="description-text">
//                     You can start with this later can be changed
//                 </p>
//             </div>
//         );
//     };


//     // const renderDescription = (): JSX.Element => {
//     //     return (
//     //         <div className='container'>
//     //             <text.T16
//     //                 style={{
//     //                     lineHeight: 1,
//     //                     textAlign: 'center',
//     //                     whiteSpace: 'pre-line',
//     //                     marginBottom: 10,
//     //                 }}
//     //             >
//     //                 You can start with this later can be changed
//     //             </text.T16>
//     //         </div>
//     //     );
//     // };
//     const renderButtons = (): JSX.Element => (
//         <div
//             style={{
//                 position: 'absolute',
//                 bottom: 0,
//                 width: '100%',
//                 padding: '36px 16px 36px 16px',
//                 background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.47) 0%, #FFFFFF 100%)',
//                 backdropFilter: 'blur(4px)',
//                 boxSizing: 'border-box',
//             }}
//         >
//             <div
//                 className='button-container'
//                 style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
//             >
//                 {renderTitle()}
//                 {renderDescription()}

//                 {buttons.map((btn, index) => (
//                     <>

//                         <div
//                             key={index}
//                             id="onbording1"
//                             className={index === 0 ? 'active-button' : 'inactive-button'}
//                             onClick={() => navigate(btn.path)}
//                         >
//                             <img src={btn.icon} alt="" className="onboarding-icon" />
//                             <span>{btn.title}</span>
//                         </div>


//                         {/* <components.Button
//                             key={index}
//                             style={{
//                                 backgroundColor: index === 0 ? '#7065F0' : '#fff',
//                                 color: index === 0 ? '#fff' : '#7065F0',
//                                 border: '1px solid #7065F0',
//                             }}
//                             title={btn.title}
//                             onClick={() => navigate(btn.path)}
//                         /> */}
//                     </>
//                 ))}

//             </div >
//         </div>
//     );

//     return (
//         // <div style={{ position: 'relative', height: '100vh', width: '100vw', overflow: 'hidden' }}>
//         //     <div style={{ width: '100%', height: '100vh', overflow: 'hidden', position: 'relative' }}>
//         //         <img
//         //             src={require('../assets/nestfin/mainb1.jpg')}
//         //             alt='Onboarding Visual'
//         //             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//         //         />
//         //         {renderButtons()}
//         //     </div>
//         // </div>
//         <div style={{ position: 'relative', height: '100dvh', overflow: 'hidden' }}>
//             <div
//                 style={{
//                     width: '100%',
//                     height: '100%',
//                     overflow: 'hidden',
//                     position: 'relative',
//                 }}
//             >
//                 <img
//                     src={require('../assets/nestfin/mainb1.jpg')}
//                     alt='Onboarding Visual'
//                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//                 {renderButtons()}
//             </div>
//         </div>

//     );
// };













// ************************************************

// import { useLocation } from 'react-router-dom';
// import React from 'react';
// import useEmblaCarousel from 'embla-carousel-react';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { theme } from '../constants';
// import { svg } from '../assets/svg';
// import { components } from '../components';
// import home from '../assets/nestfin/key.png'
// import owner from '../assets/nestfin/house.png'

// export const Onboarding1: React.FC = () => {
//     const { pathname } = useLocation();
//     const navigate = hooks.useNavigate();

//     const buttons = [
//         {
//             title: 'Rent as Tenant',
//             path: '/onbording3',
//             icon: home
//         },
//         {
//             title: 'Rent as Owner',
//             path: '/onbording3',
//             icon: owner
//         },
//     ];

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container'>
//                 <p className='heading'>What are you looking for?</p>
//                 {/* <text.H2
//                     style={{
//                         textAlign: 'center',
//                         textTransform: 'capitalize',
//                         color: "#7065F0",
//                         lineHeight: 1,
//                     }}
//                 >
//                     What are you looking for?
//                 </text.H2> */}
//             </div>
//         );
//     };

//     const renderDescription = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <p className="description-text">
//                     You can start with this later can be changed
//                 </p>
//             </div>
//         );
//     };


//     // const renderDescription = (): JSX.Element => {
//     //     return (
//     //         <div className='container'>
//     //             <text.T16
//     //                 style={{
//     //                     lineHeight: 1,
//     //                     textAlign: 'center',
//     //                     whiteSpace: 'pre-line',
//     //                     marginBottom: 10,
//     //                 }}
//     //             >
//     //                 You can start with this later can be changed
//     //             </text.T16>
//     //         </div>
//     //     );
//     // };
//     const renderButtons = (): JSX.Element => (
//         <div
//             style={{
//                 position: 'absolute',
//                 bottom: 0,
//                 width: '100%',
//                 padding: '36px 16px 36px 16px',
//                 background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.47) 0%, #FFFFFF 100%)',
//                 backdropFilter: 'blur(4px)',
//                 boxSizing: 'border-box',
//             }}
//         >
//             <div
//                 className='button-container'
//                 style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
//             >
//                 {renderTitle()}
//                 {renderDescription()}

//                 {buttons.map((btn, index) => (
//                     <>

//                         <div
//                             key={index}
//                             id="onbording1"
//                             className={index === 0 ? 'active-button' : 'inactive-button'}
//                             onClick={() => navigate(btn.path)}
//                         >
//                             <img src={btn.icon} alt="" className="onboarding-icon" />
//                             <span>{btn.title}</span>
//                         </div>


//                         {/* <components.Button
//                             key={index}
//                             style={{
//                                 backgroundColor: index === 0 ? '#7065F0' : '#fff',
//                                 color: index === 0 ? '#fff' : '#7065F0',
//                                 border: '1px solid #7065F0',
//                             }}
//                             title={btn.title}
//                             onClick={() => navigate(btn.path)}
//                         /> */}
//                     </>
//                 ))}

//             </div >
//         </div>
//     );

//     return (
//         <div style={{ position: 'relative', minHeight: '100vh' }}>
//             <div style={{ width: '100%', height: '100vh', overflow: 'hidden', position: 'relative' }}>
//                 <img
//                     src={require('../assets/nestfin/mainb1.jpg')}
//                     alt='Onboarding Visual'
//                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//                 {renderButtons()}
//             </div>
//         </div>
//     );
// };
